/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getViewportInfo, isMobileWeb } from '@tcp/core/src/utils';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import { getIconPath } from '@tcp/core/src/utils/utils';
import { COUPON_REDEMPTION_TYPE } from '@tcp/core/src/services/abstractors/CnC/CartItemTile';
import NewCouponCard from '@tcp/core/src/components/common/molecules/NewCouponCard/views/NewCouponCard.view';
import CouponList from '@tcp/core/src/components/common/molecules/HorizontalCarouselCNC/views/CouponList';
import BodyCopy from '../../../../../../../common/atoms/BodyCopy';
import CouponCard from '../../../../../../../common/molecules/CouponCard';
import { EmptyOffersList } from '../EmptyOffersList.view';
import HorizontalCarouselCNCView from '../../../../../../../common/molecules/HorizontalCarouselCNC/views/HorizontalCarouselCNC.view';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, { CHECKOUT_LABELS } from '../../../../labels/AccountCommon.labels';

const ACCOUNT_REWARDS_SLICE_COUNT = 6;

function calculateSlidesToShow({ isPlacePerks, isNewCouponDesign, isWallet }) {
  let slidesToShow = 1;

  if (isPlacePerks || isNewCouponDesign || isWallet) {
    if (isWallet) {
      slidesToShow = 1.2;
    } else {
      slidesToShow = 1.075;
    }
  }

  return slidesToShow;
}

function calculateSlidesToShowTabletView({ isNewCouponDesign, isDashboardORPlacePerks, isWallet }) {
  let slidesToShow;

  if (isNewCouponDesign) {
    slidesToShow = 1;
  } else if (isWallet || isDashboardORPlacePerks) {
    slidesToShow = 2.2;
  } else {
    slidesToShow = 3;
  }

  return slidesToShow;
}

function calculateSlidesToShowSmallerTabletView({
  isNewCouponDesign,
  isDashboardORPlacePerks,
  isWallet,
}) {
  let slidesToShow;

  if (isNewCouponDesign) {
    slidesToShow = 1;
  } else if (isWallet || isDashboardORPlacePerks) {
    slidesToShow = 2.1;
  } else {
    slidesToShow = 2;
  }

  return slidesToShow;
}

const getSlidesToShow = ({ isDashboardORPlacePerks, spc, spcBag }) => {
  let slideToShow;
  if (isDashboardORPlacePerks) {
    slideToShow = 3.5;
  } else if (spc) {
    slideToShow = isMobileWeb() ? 1.1 : 2.2;
  } else if (spcBag) {
    slideToShow = isMobileWeb() ? 1.1 : 1.4;
  } else slideToShow = 1;
  return slideToShow;
};

const renderCarouselOption = (
  isAccountDashboard,
  isAccountDrawer,
  isPlacePerkEnabled,
  isPlacePerks,
  isCartPageCouponSection,
  spc,
  spcBag,
  isWallet
) => {
  const isNewCouponDesign = spc || spcBag;
  const isDashboardORPlacePerks = isAccountDashboard || (isPlacePerkEnabled && isPlacePerks);

  const carouselArrowsEnabled =
    !isAccountDrawer && !isAccountDashboard && !isPlacePerkEnabled && !isPlacePerks;
  const responsiveSettings = isDashboardORPlacePerks
    ? [
        {
          breakpoint: 2700,
          settings: {
            autoplay: false,
            arrows: false,
            slidesToShow: isNewCouponDesign ? 1.25 : 4.5,
            initialSlide: 0,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1800,
          settings: {
            autoplay: false,
            arrows: false,
            slidesToShow: isNewCouponDesign ? 1.25 : 3.5,
            initialSlide: 0,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1450,
          settings: {
            autoplay: false,
            arrows: false,
            slidesToShow: calculateSlidesToShowTabletView({
              isNewCouponDesign,
              isDashboardORPlacePerks,
              isWallet,
            }),
            initialSlide: 0,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 780,
          settings: {
            autoplay: false,
            arrows: false,
            swipe: true,
            slidesToShow: calculateSlidesToShowSmallerTabletView({
              isNewCouponDesign,
              isDashboardORPlacePerks,
              isWallet,
            }),
            initialSlide: 0,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            autoplay: false,
            arrows: false,
            swipe: true,
            slidesToShow: calculateSlidesToShow({ isPlacePerks, isNewCouponDesign, isWallet }),
            initialSlide: 0,
            slidesToScroll: 1,
          },
        },
      ]
    : [
        {
          settings: {
            arrows: true,
          },
        },
      ];
  return {
    autoplay: false,
    arrows: carouselArrowsEnabled,
    autoplaySpeed: 4000,
    infinite: false,
    initialSlide: 0,
    fade: false,
    speed: 500,
    dots: true,
    dotsClass: 'slick-dots',
    focusOnSelect: !isDashboardORPlacePerks,
    swipe: true,
    swipeToSlide: true,
    slidesToShow: getSlidesToShow({ isDashboardORPlacePerks, spc, spcBag }),
    responsive: responsiveSettings,
  };
};

const getAccountDrawerCarouselNewClassName = (props) => {
  const { isAccountDrawer, isAccountDashboard, isPlacePerkEnabled, isPlacePerks } = props;

  return isAccountDrawer || isAccountDashboard || (isPlacePerkEnabled && isPlacePerks)
    ? 'account-drawer-carousel-new'
    : '';
};

const getCouponSliceCount = (props) => {
  const { isAccountDrawer, isAccountDashboard, isPlacePerks, sliceCount, isNewAccountDrawer } =
    props;
  let couponSliceCount = sliceCount;

  if (isNewAccountDrawer) {
    return 4;
  }

  if (isAccountDashboard || isAccountDrawer || isPlacePerks) {
    couponSliceCount = ACCOUNT_REWARDS_SLICE_COUNT;
  }

  return couponSliceCount;
};

const getCouponList = (props) => {
  const {
    allCouponList,
    isPlacePerkEnabled,
    isPlacePerks,
    fromPlaceRewards,
    isBonusPointDayEnabled,
    isFromMPRPage,
  } = props;
  let couponList = allCouponList;
  if (isPlacePerkEnabled && isPlacePerks && !fromPlaceRewards) {
    couponList = allCouponList?.filter((coupon) => {
      return coupon.offerType === COUPON_REDEMPTION_TYPE.PLACEPERKS;
    });
  }
  if (fromPlaceRewards && isBonusPointDayEnabled) {
    couponList = allCouponList?.filter((coupon) => {
      return coupon?.originalOfferType === COUPON_REDEMPTION_TYPE.BONUSPOINTDAY;
    });
  }
  if (isFromMPRPage) {
    couponList = allCouponList?.filter((coupon) => {
      return coupon?.originalOfferType !== COUPON_REDEMPTION_TYPE.BONUSPOINTDAY;
    });
  }

  return couponList;
};
const couponCardView = (props, coupon) => {
  const {
    isFetching,
    labels,
    commonLabels,
    handleApplyCouponFromList,
    handleRemoveCoupon,
    handleErrorCoupon,
    isCarouselView,
    isAccountDrawer,
    isAccountDashboard,
    isPlacePerkEnabled,
    isPlacePerks,
    accountLabels,
    autoApplyPerkCouponType,
    couponDetailClick,
    isCartPageCouponSection,
    toggleNeedHelpModal,
    spc,
    isWallet,
    couponOnHoldNewDesign,
    bonusPointDayData,
    isBonusPointDayEnabled,
    currentPerkLevel,
    setBonusPointDayCouponIndexAction,
    fromIsApplyAction,
    fromApplyCTA,
    ledgerSummaryData,
    isNewCouponUXWithoutTabEnabled,
    isFromBagPage,
    multiAddCouponLoader,
    totalPriceOfAllLicensedProducts,
  } = props;
  const toggleCouponNeedHelpModal = () => {
    toggleNeedHelpModal();
  };
  const couponList = getCouponList(props);

  return (
    <>
      <CouponCard
        key={coupon.id}
        labels={labels}
        commonLabels={commonLabels}
        isFetching={isFetching}
        coupon={coupon}
        handleErrorCoupon={handleErrorCoupon}
        couponDetailClick={couponDetailClick}
        helpAnchorClick={toggleCouponNeedHelpModal}
        onApply={handleApplyCouponFromList}
        onRemove={handleRemoveCoupon}
        isCarouselView={isCarouselView}
        className="coupon-slider"
        isAccountDrawer={isAccountDrawer}
        isAccountDashboard={isAccountDashboard}
        couponListSize={couponList?.size}
        isPlacePerkEnabled={isPlacePerkEnabled}
        isPlacePerks={isPlacePerks}
        accountLabels={accountLabels}
        autoApplyPerkCouponType={autoApplyPerkCouponType}
        isCartPageCouponSection={isCartPageCouponSection}
        spc={spc}
        isWallet={isWallet}
        couponOnHoldNewDesign={couponOnHoldNewDesign}
        bonusPointDayData={bonusPointDayData}
        isBonusPointDayEnabled={isBonusPointDayEnabled}
        currentPerkLevel={currentPerkLevel}
        setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
        fromIsApplyAction={fromIsApplyAction}
        fromApplyCTA={fromApplyCTA}
        ledgerSummaryData={ledgerSummaryData}
        isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
        isFromBagPage={isFromBagPage}
        multiAddCouponLoader={multiAddCouponLoader}
        totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
      />
    </>
  );
};
const newCouponCardView = (props, coupon) => {
  const {
    isFetching,
    labels,
    commonLabels,
    handleApplyCouponFromList,
    handleRemoveCoupon,
    handleErrorCoupon,
    isCarouselView,
    isAccountDrawer,
    isAccountDashboard,
    isPlacePerkEnabled,
    isPlacePerks,
    accountLabels,
    autoApplyPerkCouponType,
    couponDetailClick,
    isCartPageCouponSection,
    toggleNeedHelpModal,
    spc,
    isWallet,
    couponOnHoldNewDesign,
    bonusPointDayData,
    isBonusPointDayEnabled,
    currentPerkLevel,
    setBonusPointDayCouponIndexAction,
    fromIsApplyAction,
    fromApplyCTA,
    ledgerSummaryData,
    isNewCouponUXWithoutTabEnabled,
    isFromBagPage,
    multiAddCouponLoader,
    isCheckout,
    isNewAccountDrawer,
  } = props;
  const toggleCouponNeedHelpModal = () => {
    toggleNeedHelpModal();
  };
  const couponList = getCouponList(props);

  return (
    <>
      <NewCouponCard
        key={coupon.id}
        labels={labels}
        commonLabels={commonLabels}
        isFetching={isFetching}
        coupon={coupon}
        handleErrorCoupon={handleErrorCoupon}
        couponDetailClick={couponDetailClick}
        helpAnchorClick={toggleCouponNeedHelpModal}
        onApply={handleApplyCouponFromList}
        onRemove={handleRemoveCoupon}
        isCarouselView={isCarouselView}
        className="coupon-slider"
        isAccountDrawer={isAccountDrawer}
        isAccountDashboard={isAccountDashboard}
        couponListSize={couponList?.size}
        isPlacePerkEnabled={isPlacePerkEnabled}
        isPlacePerks={isPlacePerks}
        accountLabels={accountLabels}
        autoApplyPerkCouponType={autoApplyPerkCouponType}
        isCartPageCouponSection={isCartPageCouponSection}
        spc={spc}
        isWallet={isWallet}
        couponOnHoldNewDesign={couponOnHoldNewDesign}
        bonusPointDayData={bonusPointDayData}
        isBonusPointDayEnabled={isBonusPointDayEnabled}
        currentPerkLevel={currentPerkLevel}
        setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
        fromIsApplyAction={fromIsApplyAction}
        fromApplyCTA={fromApplyCTA}
        ledgerSummaryData={ledgerSummaryData}
        isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
        isFromBagPage={isFromBagPage}
        multiAddCouponLoader={multiAddCouponLoader}
        isCheckout={isCheckout}
        isNewAccountDrawer={isNewAccountDrawer}
      />
    </>
  );
};

const getAvailableCouponWalletList = (couponList = [], couponOnHoldNewDesign = 'false') => {
  if (couponOnHoldNewDesign) {
    return couponList?.filter(
      (coupon) => coupon?.status === 'available' && coupon?.isOnHold !== 'true'
    );
  }
  return couponList?.filter((coupon) => coupon?.status === 'available');
};

const getAppliedCouponWalletList = (couponList = [], couponOnHoldNewDesign = 'false') => {
  if (couponOnHoldNewDesign) {
    return couponList?.filter(
      (coupon) => coupon?.status === 'applied' || coupon?.isOnHold === 'true'
    );
  }
  return couponList?.filter((coupon) => coupon?.status === 'applied');
};

const appliedCouponsView = (props) => {
  const { couponOnHoldNewDesign } = props;
  const couponList = getCouponList(props);
  const appliedCouponWalletList = getAppliedCouponWalletList(couponList, couponOnHoldNewDesign);

  return appliedCouponWalletList.map((coupon) => {
    return <>{couponCardView(props, coupon)}</>;
  });
};

const availableCouponsView = (props) => {
  const { couponOnHoldNewDesign } = props;
  const couponList = getCouponList(props);
  const availableCouponWalletList = getAvailableCouponWalletList(couponList, couponOnHoldNewDesign);

  return availableCouponWalletList?.map((coupon) => {
    return <>{couponCardView(props, coupon)}</>;
  });
};

const renderEmptyReward = (props) => {
  const { isAccountDashboard, commonLabels, closedOverlay } = props;

  return (
    <EmptyOffersList
      newRewardsAndOffers={isAccountDashboard}
      commonLabels={commonLabels}
      closedOverlay={closedOverlay}
    />
  );
};

const renderCouponViews = ({
  props,
  appliedCouponWalletList,
  appliedCouponText,
  availableCouponWalletList,
  availableCouponText,
  couponsToRender,
  isNewAccountDrawer,
}) => {
  const {
    isAccountDrawer,
    isAccountDashboard,
    isPlacePerkEnabled,
    isPlacePerks,
    isCartPageCouponSection,
    spc,
    spcBag,
    isWallet,
    variation,
    isCouponSmoothScrollEnabled,
    displayCards,
    couponSelfHelp,
    fromBagPage,
    isNewCouponUXWithoutTabEnabled,
    isLoyaltyTieringEnabled,
    totalPriceOfAllLicensedProducts,
  } = props;
  const { isTablet } = getViewportInfo();

  if (isWallet && (isMobileWeb() || isTablet)) {
    if (variation === 'smooth-carousel' && isCouponSmoothScrollEnabled) {
      return (
        <div>
          {appliedCouponWalletList?.size > 0 && (
            <div className="mpr-applied-section">
              <p className="mpr-coupons-header">{appliedCouponText}</p>

              <HorizontalCarouselCNCView
                childrenComp={couponCardView}
                data={appliedCouponWalletList}
                displayCards={displayCards}
                totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
                {...props}
              />
            </div>
          )}
          {availableCouponWalletList?.size > 0 && (
            <div className="mpr-applied-section">
              <p className="mpr-coupons-header">{availableCouponText}</p>

              <HorizontalCarouselCNCView
                childrenComp={couponCardView}
                data={availableCouponWalletList}
                displayCards={displayCards}
                fromBagPage={fromBagPage}
                totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
                {...props}
              />
            </div>
          )}
        </div>
      );
    }
    return (
      <>
        {appliedCouponWalletList?.size > 0 && (
          <div className="coupon-wallet-carousel">
            <p className="wallet-coupons-header">{appliedCouponText}</p>
            <Carousel
              options={renderCarouselOption(
                isAccountDashboard,
                isAccountDrawer,
                isPlacePerkEnabled,
                isPlacePerks,
                isCartPageCouponSection,
                spc,
                spcBag,
                isWallet
              )}
              carouselConfig={{
                customArrowLeft: getIconPath('smallright'),
                customArrowRight: getIconPath('smallright'),
                arrow: 'small',
                type: 'light',
              }}
              carouselTheme="dark"
              isCartPageCouponSection={isCartPageCouponSection}
            >
              {appliedCouponWalletList?.map((coupon) => couponCardView(props, coupon))}
            </Carousel>
          </div>
        )}
        {availableCouponWalletList?.size > 0 && (
          <div className="coupon-wallet-carousel">
            <p className="wallet-coupons-header">{availableCouponText}</p>
            <Carousel
              options={renderCarouselOption(
                isAccountDashboard,
                isAccountDrawer,
                isPlacePerkEnabled,
                isPlacePerks,
                isCartPageCouponSection,
                spc,
                spcBag,
                isWallet
              )}
              carouselConfig={{
                customArrowLeft: getIconPath('smallright'),
                customArrowRight: getIconPath('smallright'),
                arrow: 'small',
                type: 'light',
              }}
              carouselTheme="dark"
              isCartPageCouponSection={isCartPageCouponSection}
            >
              {availableCouponWalletList?.map((coupon) => couponCardView(props, coupon))}
            </Carousel>
          </div>
        )}
      </>
    );
  }
  if (isWallet) {
    return (
      <>
        {appliedCouponWalletList?.size > 0 && (
          <>
            <div className="coupon-wallet-carousel">
              <p className="wallet-coupons-header">{appliedCouponText}</p>
              <div className="coupon-applied">{appliedCouponsView(props)}</div>
            </div>
          </>
        )}
        {availableCouponWalletList?.size > 0 && (
          <>
            <p className="wallet-coupons-header">{availableCouponText}</p>
            <div className="coupon-available">{availableCouponsView(props)}</div>
          </>
        )}
      </>
    );
  }

  if (isNewAccountDrawer || (variation === 'smooth-carousel' && isCouponSmoothScrollEnabled)) {
    if (isLoyaltyTieringEnabled) {
      return (
        <CouponList
          childrenComp={newCouponCardView}
          data={couponsToRender}
          isNewAccountDrawer={isNewAccountDrawer}
          {...props}
        />
      );
    }
    return (
      <HorizontalCarouselCNCView
        childrenComp={couponCardView}
        data={couponsToRender}
        displayCards={displayCards}
        couponSelfHelp={couponSelfHelp}
        isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
        {...props}
      />
    );
  }
  return (
    <Carousel
      options={renderCarouselOption(
        isAccountDashboard,
        isAccountDrawer,
        isPlacePerkEnabled,
        isPlacePerks,
        isCartPageCouponSection,
        spc,
        spcBag,
        isWallet
      )}
      carouselConfig={{
        customArrowLeft: getIconPath('smallright'),
        customArrowRight: getIconPath('smallright'),
        arrow: 'small',
        type: 'light',
      }}
      carouselTheme="dark"
      isCartPageCouponSection={isCartPageCouponSection}
    >
      {couponsToRender?.map((coupon) => {
        return couponCardView(props, coupon);
      })}
    </Carousel>
  );
};
export default function OffersCarouselView(props) {
  const {
    isAccountDrawer,
    isPlacePerks,
    spc,
    spcBag,
    couponOnHoldNewDesign,
    isLoyaltyTieringEnabled,
    isNewAccountDrawer,
  } = props;
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, AccountCommonLabels);

  const carouselNewClassName = getAccountDrawerCarouselNewClassName(props);
  const couponSliceCount = getCouponSliceCount(props);
  const couponList = getCouponList(props);
  const couponsToRender = spc || spcBag ? couponList : couponList?.slice(0, couponSliceCount);
  const availableCouponWalletList = getAvailableCouponWalletList(couponList, couponOnHoldNewDesign);
  const appliedCouponWalletList = getAppliedCouponWalletList(couponList, couponOnHoldNewDesign);
  const getLoyaltyLabels = isLoyaltyTieringEnabled
    ? renderLabel(
        checkoutLabels?.bagPage?.lbl_loyalty_coupon_collapsible_header,
        'lbl_loyalty_coupon_collapsible_header'
      )
    : renderLabel(
        checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
        'lbl_coupon_collapsible_header'
      );
  const availableCouponText = `${renderLabel(
    checkoutLabels?.bagPage?.lbl_couponlist_available,
    'lbl_couponlist_available'
  )}
  ${getLoyaltyLabels}
  (${availableCouponWalletList?.size})`;
  const appliedCouponText = `${renderLabel(
    checkoutLabels?.bagPage?.lbl_couponlist_applied,
    'lbl_couponlist_applied'
  )}
  ${getLoyaltyLabels}
  (${appliedCouponWalletList?.size})`;

  return couponList ? (
    <BodyCopy component="div" className={`coupon_carousel ${carouselNewClassName}`}>
      {couponList?.size > 0 &&
        renderCouponViews({
          props,
          appliedCouponWalletList,
          appliedCouponText,
          availableCouponWalletList,
          availableCouponText,
          couponsToRender,
          isLoyaltyTieringEnabled,
          isNewAccountDrawer,
        })}
      {!isAccountDrawer && !isPlacePerks && couponList?.size === 0 && renderEmptyReward(props)}
    </BodyCopy>
  ) : null;
}

OffersCarouselView.propTypes = {
  couponDetailClick: PropTypes.func.isRequired,
  goToWalletPage: PropTypes.func.isRequired,
  labels: PropTypes.shape({}).isRequired,
  isFetching: PropTypes.bool.isRequired,
  handleRemoveCoupon: PropTypes.func.isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  isCarouselView: PropTypes.bool,
  commonLabels: PropTypes.shape({}).isRequired,
  handleApplyCouponFromList: PropTypes.func.isRequired,
  toggleNeedHelpModal: PropTypes.func.isRequired,
  isAccountDrawer: PropTypes.bool,
  isAccountDashboard: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  accountLabels: PropTypes.shape({}).isRequired,
  autoApplyPerkCouponType: PropTypes.string,
  isNewAccountDrawer: PropTypes.bool,
};
OffersCarouselView.defaultProps = {
  isCarouselView: false,
  isAccountDrawer: false,
  isAccountDashboard: false,
  isPlacePerks: false,
  isPlacePerkEnabled: false,
  autoApplyPerkCouponType: '',
  isNewAccountDrawer: false,
};
